import {
  Button,
  HStack,
  Icon,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Tag,
  Text,
  Link,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SearchResponseItem } from "@/lib/SemanticScholarApi";
import { IoHelpCircleOutline } from "react-icons/io5";
import { LuExternalLink } from "react-icons/lu";
type ImpactFactorInfoProps = {
  impactFactorInfo?: SearchResponseItem["impact_factor_info"];
};

const QuartilesColors = {
  Q1: "green.500",
  Q2: "green.300",
  Q3: "yellow.400",
  Q4: "orange.400",
};

const ImpactFactorInfo = ({ impactFactorInfo }: ImpactFactorInfoProps) => {
  const { t } = useTranslation();
  return impactFactorInfo ? (
    <HStack spacing={2} wrap={"wrap"}>
      <Tag
        backgroundColor={
          QuartilesColors[
            impactFactorInfo.quartile as keyof typeof QuartilesColors
          ]
        }
        color={"white"}
      >
        {impactFactorInfo.quartile}
      </Tag>
      <Tag>
        <Text
          overflow={"hidden"}
          textOverflow={"ellipsis"}
          whiteSpace={"nowrap"}
        >
          {t(`search.filters.impactFactor.score`, {
            score: impactFactorInfo.jif,
          })}
        </Text>
      </Tag>

      <Popover>
        <PopoverTrigger>
          <Tag as={Button} h={4} rightIcon={<Icon as={IoHelpCircleOutline} />}>
            <Text
              overflow={"hidden"}
              textOverflow={"ellipsis"}
              whiteSpace={"nowrap"}
            >
              {t(`search.filters.impactFactor.category`, {
                category: impactFactorInfo.category_name,
                rank: impactFactorInfo.rank,
                count: impactFactorInfo.number_of_journals,
              })}
            </Text>
          </Tag>
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverBody>
            <Text
              textAlign={"center"}
              fontSize={16}
              lineHeight={1.2}
              borderBottom={"1px solid #b0b0b0"}
              marginBottom={2}
              paddingBottom={2}
            >
              {t(`search.filters.impactFactor.category`, {
                category: impactFactorInfo.category_name,
                rank: impactFactorInfo.rank,
                count: impactFactorInfo.number_of_journals,
              })}
            </Text>
            <Text>{t("search.filters.impactFactor.description")}</Text>
            <Link
              target="_blank"
              color={"brand.500"}
              textDecoration={"underline"}
              href={
                "https://www.researchgate.net/publication/381580823_Journal_Citation_Reports_JCR_Impact_Factor_2024_PDF_Web_of_Science"
              }
            >
              {t("search.filters.impactFactor.link")}
              <Icon
                as={LuExternalLink}
                ml={1}
                color={"brand.500"}
                boxSize={4}
                verticalAlign={"middle"}
              />
            </Link>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </HStack>
  ) : null;
};

export default ImpactFactorInfo;
